import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { StoreMst } from '../../../interfaces/masters/storemst';

@Injectable()
export class StoreMstApi {
    private readonly apiController: string = 'storemst';

    constructor(private api: HttpService) { } 

    
  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    //header.append('Content-Type', 'applications/json');
    //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    //header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
  getById(url : string, options?: any): Observable<StoreMst> { 
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: StoreMst):Observable<StoreMst[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    // const formData: FormData = new FormData();
    // formData.append('Image', data.photo);
    // data.photo = formData;
    return this.api.post( url, data, header);
  }

  update(url:string, data: StoreMst):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    // const formData: FormData = new FormData();
    // formData.append('Image', data.photo);
    // data.photo = formData;
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
  
  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
  
}
